<template>
  <div>
    <add-user
      ref="addUser"
      @action="setLoading"
      @refreshUser="reload"
    ></add-user>
    <edit-user
      ref="editUser"
      @action="setLoading"
      @remove="setRemovingUser"
      @refreshUser="reload"
    ></edit-user>
    <v-container>
      <v-row class="justify-center">
        <v-col cols="12" sm="11" lg="11" class="px-0">
          <div class="users-sticky-header">
            <div class="controls-row">
              <v-text-field
                v-model="searchString"
                outlined
                dense
                hide-details
                clearable
                placeholder="Pretraži korisnike"
                prepend-inner-icon="mdi-magnify"
                class="filter-select controls-search"
                @input="onSearchInput"
                @click:clear="onSearchClear"
              ></v-text-field>
              <v-select
                outlined
                dense
                hide-details
                label="Firma"
                :items="companies"
                v-model="company"
                return-object
                item-text="name"
                item-value="id"
                @change="companyChange"
                @click:clear="resetAll"
                clearable
                class="filter-select controls-select"
              ></v-select>
              <v-select
                outlined
                dense
                hide-details
                label="Prodajno mjesto"
                :items="locations"
                v-model="location"
                item-text="name"
                item-value="id"
                return-object
                clearable
                @change="resetInfiniteLoader"
                @click:clear="resetInfiniteLoader"
                class="filter-select controls-select"
              ></v-select>
              <v-spacer></v-spacer>
              <v-btn elevation="0" class="add-user-btn" @click="addUser">
                <v-icon left small>mdi-plus</v-icon>
                Dodaj korisnika
              </v-btn>
            </div>

            <div class="users-thead">
              <div class="users-thead-cell" style="width: 12%;">Prezime</div>
              <div class="users-thead-cell" style="width: 12%;">Ime</div>
              <div class="users-thead-cell hidden-md-and-down" style="width: 130px; flex: 0 0 130px;">OIB</div>
              <div class="users-thead-cell hidden-md-and-down text-center" style="width: 10%;">Aktivan</div>
              <div class="users-thead-cell" style="width: 22%;">Korisničko ime</div>
              <div class="users-thead-cell" style="width: 22%;">Privilegije</div>
              <div style="width: 6%;"></div>
            </div>
          </div>

          <div class="users-tbody users-rows-body infinite-wrapper">
            <v-card
              v-for="(doc, i) in sortedUsers"
              :key="i"
              :class="['user-card', doc.user.active ? 'user-card-active' : 'user-card-inactive']"
              tabindex="0"
            >
              <v-row class="ma-0 align-center" style="min-height: 60px;">
                <div class="user-cell user-name text-capitalize" style="width: 12%;">
                  {{ doc.user.surname }}
                </div>
                <div class="user-cell user-name text-capitalize" style="width: 12%;">
                  {{ doc.user.name }}
                </div>
                <div class="user-cell hidden-md-and-down" style="width: 130px; flex: 0 0 130px; white-space: nowrap;">
                  {{ doc.user.oib }}
                </div>
                <div class="user-cell hidden-md-and-down text-center" style="width: 10%;">
                  <v-chip x-small class="status-chip-active" v-if="doc.config.active">Aktivan</v-chip>
                  <v-chip x-small class="status-chip-inactive" v-else>Neaktivan</v-chip>
                </div>
                <div class="user-cell" style="width: 22%;">
                  {{ doc.user.email }}
                </div>
                <div class="user-cell" style="width: 22%;">
                  <span
                    class="text-capitalize"
                    v-for="(role, i) in doc.user.roles ? Object.keys(doc.user.roles) : []"
                    :key="role"
                  >
                    <span v-if="doc.user.roles[role]">{{
                      `${role}${
                        doc.user.roles &&
                        Object.keys(doc.user.roles).length - 1 > i
                          ? ", "
                          : ""
                      }`
                    }}</span>
                  </span>
                </div>
                <div class="user-cell d-flex justify-center" style="width: 6%;">
                  <v-btn
                    tabindex="-1"
                    icon
                    @click.stop="editUser(doc.user)"
                    @keypress.enter.stop=""
                  >
                    <v-icon color="#94A3B8">mdi-dots-vertical</v-icon>
                  </v-btn>
                </div>
              </v-row>
            </v-card>

            <infinite-loading
              ref="InfiniteLoading"
              :force-use-infinite-wrapper="true"
              @infinite="infiniteHandler"
              spinner="waveDots"
            >
              <div slot="no-more"></div>
              <div slot="no-results">
                <v-card>
                  <v-row class="ma-0 status-processing justify-center">
                    <v-col>
                      <div class="text-center">
                        Ne postoje korisnici po odabranim kriterijima.
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </infinite-loading>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import applicationSettings from '@/mixins/applicationSettings'
import trigram from '@/mixins/trigram'
import addUser from '@/modules/companies/components/users/components/AddUser'
import editUser from '@/modules/companies/components/users/components/EditUser'
import { auth, df } from '@/plugins/firebase'
import { clone, duck } from '@/plugins/utils'
import InfiniteLoading from 'vue-infinite-loading'
import state from '@/state'
import EventBus from '@/plugins/event-bus'
import { collection, query, orderBy, getDocs, where, limit, startAfter } from 'firebase/firestore'

export default {
  name: 'Users',
  mixins: [applicationSettings, trigram],
  components: { addUser, editUser, InfiniteLoading },
  data: function () {
    return {
      visible: false,
      loading: false,
      lastVisible: '',
      submitting: false,
      companies: [],
      company: undefined,
      locations: [],
      location: undefined,
      registers: [],
      register: undefined,
      users: [],
      sortDirections: [
        { name: 'Uzlazno', id: 'asc' },
        { name: 'Silazno', id: 'desc' }
      ],
      sortDirection: { name: 'Uzlazno', id: 'asc' },
      sortOption: { name: 'Korisničko ime', id: 'email' },
      sortOptions: [
        { name: 'Ime', id: 'name' },
        { name: 'Prezime', id: 'surname' },
        { name: 'Korisničko ime', id: 'email' }
      ],
      removingUser: undefined,
      searchEmitDestination: 'userSearch',
      searchString: ''
    }
  },
  computed: {
    sortedUsers () {
      const localUsers = clone(this.users)
      return localUsers.sort((a, b) => a.user.surname.localeCompare(b.user.surname))
    }
  },
  mounted () {
    const user = state.getUser()

    if (!user.roles.ADMIN && !user.roles.SUPERADMIN) {
      this.$router.push({
        name: 'pointOfSale.cashRegisters',
        params: { companyId: state.getCurrentCompany().id, locationId: state.getPointOfSale().id }
      }).catch(err => {
        // Ignore NavigationDuplicated error
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      })
      return
    }
    this.listeners.push(
      df.doc(`user_companies/${auth.currentUser.uid}`).onSnapshot(doc => {
        if (doc?.data()?.companies) {
          const companies = Object.keys(doc.data().companies).map(key => {
            return doc.data().companies[key]
          })
          this.companies = clone(companies.sort((a, b) => a.name.localeCompare(b.name)))

          if (!duck(state.getCurrentCompany(), {})) {
            this.company = this.companies.find(company => state.getCurrentCompany().id === company.id)
          } else {
            this.company = this.companies[0]
          }
          this.companyChange()
        }
      })
    )

    EventBus.$on('add-role', _user => {
      if (this.$refs?.editUser) {
        this.$refs.editUser.open(_user, state.getCurrentCompany())
      }
    })

    EventBus.$on(this.searchEmitDestination, (searchObject) => {
      // console.log(searchObject.triGramObject)
      if (!searchObject.triGramObject) {
        this.lastDocSnapshot = null
        this.detachListeners()
        this.resetHandler()
      } else {
        this.getUsers(searchObject.triGramObject)
      }
    })
  },
  watch: {
    search () {
      this.lastVisible = ''
      this.users = []
      if (this.$refs.InfiniteLoading) {
        this.$refs.InfiniteLoading.stateChanger.reset()
      }
    }
  },
  methods: {
    reload () {
      setTimeout(() => {
        this.lastDocSnapshot = null
        this.detachListeners()
        this.resetHandler()
      }, 1000)
    },
    resetHandler () {
      this.users = []
      if (this.$refs.InfiniteLoading) {
        this.$refs.InfiniteLoading.stateChanger.reset()
      }
    },
    resetDefaults () {
      this.company = undefined
    },

    resetAll () {
      this.company = undefined
      this.location = undefined
      this.locations = []
      this.users = []
    },

    setRemovingUser (user) {
      this.users = this.users.map(us => {
        const ret = us
        if (us.id === user.id) ret.user.status = 'PROCESSING'
        return ret
      })
      this.removingUser = { ...user, status: 'PROCESSING' }
    },
    setLoading (user) {
      this.users = this.users.map(us => {
        const ret = us
        if (us.user.id === user.id) ret.user.status = 'PROCESSING'
        return ret
      })
      if (user.timeout && !this.location) {
        setTimeout(() => {
          this.users = this.users.map(us => {
            const ret = us
            if (us.user.id === user.id) ret.user.status = 'OK'
            return ret
          })
        }, 7000)
      }
    },
    // modifyItems (change) {
    //   if (change.type === 'added') {
    //     if (change.doc.data()) {
    //       const _document = clone(change.doc.data())
    //       if (this.users.filter(doc => doc.user.id === _document.user.id).length === 0) {
    //         this.users.push({ ..._document, ...{ [`hover-${change.doc.data().user.id}`]: false } })
    //       }
    //     }
    //   }
    //   if (change.type === 'modified') {
    //     this.users = this.users.map(item => {
    //       let ret = item
    //       if (item.user.id === change.doc.data().user.id) {
    //         const _document = clone(change.doc.data())
    //         if (_document?.user?.id === state.getUser()?.id) state.setUser(_document.user) // set refreshed user
    //         ret = _document
    //       }
    //       return { ...ret, ...{ [`hover-${change.doc.data().user.id}`]: false } }
    //     })
    //   }
    //   if (change.type === 'removed') {
    //     if (this.removingUser.id === change.doc.data().id) {
    //       this.users = this.users.filter(item => this.removingUser.user.id !== item.user.id)
    //     }
    //   }
    // },

    async infiniteHandler ($state) {
      if (!this.company) {
        return $state.complete()
      }

      const newItemsCount = await this.getUsers()
      if (newItemsCount > 0) {
        return $state.loaded() // getItems je vratio vise od nula artikala, znaci da ih ima jos
      }
      return $state.complete() // getItems je vratio 0 artikala, znaci da ih vise nema
    },

    async getUsers (triGramObject = undefined) {
      const searchConstraints = []
      if (triGramObject) {
        Object.keys(triGramObject).forEach(name =>
          searchConstraints.push(where(`user.meta.${name}`, '==', true))
        )
      }

      if (!triGramObject) {
        searchConstraints.push(orderBy('user.name', 'asc'))
      }

      if (this.lastDocSnapshot && !triGramObject) {
        searchConstraints.push(startAfter(this.lastDocSnapshot))
      }

      // searchConstraints.push(where('user.id', '!=', 'Zg4qIpxX2uNGKvjznSVnICZAVtJ2'))
      searchConstraints.push(limit(10))

      let source = 'companies'
      if (this.location) {
        source = 'locations'
      }

      const constraints = [
        collection(df, `${source}/${source === 'locations' ? this.location.id : this.company.id}/users`),
        ...searchConstraints
      ]

      const q = query.apply(this, constraints)

      const querySnapshot = await getDocs(q)
      this.lastDocSnapshot = querySnapshot.docs[querySnapshot.docs.length - 1]

      const results = []
      querySnapshot.forEach(doc => {
        if (doc.id !== 'Zg4qIpxX2uNGKvjznSVnICZAVtJ2') {
          results.push({ _id: doc.id, ...doc.data() })
        }
      })

      if (triGramObject) {
        this.users = results
        this.users = this.users.sort((a, b) => a.name.localeCompare(b.name))
        return true
      }

      this.users.push(...results)
      return results.length
    },

    // infiniteHandler ($state) {
    //   if (!this.company) {
    //     this.users = []
    //     $state.complete()
    //     return
    //   }
    //   let source = 'companies'
    //   if (this.location) {
    //     source = 'locations'
    //   }
    //   const where = this.search ? this.search.toLowerCase() : ''
    //   let query = df.collection(`${source}/${source === 'locations' ? this.location.id : this.company.id}/users`)
    //     .where('user.id', '!=', 'Zg4qIpxX2uNGKvjznSVnICZAVtJ2')
    //     .orderBy('user.id', 'asc')
    //     .limit(10)
    //     .startAfter(this.lastVisible)

    //   if (where) {
    //     query = query.where(this.sortOption.id, '>=', where).where(this.sortOption.id, '<=', where + '\uf8ff')
    //   }

    //   const listener = query
    //     .onSnapshot((doc) => {
    //       doc.docChanges().forEach((change) => {
    //         this.modifyItems(change)
    //       })
    //       if (doc && !doc.empty) {
    //         if (doc.docs[doc.docs.length - 1]) {
    //           this.lastVisible = doc.docs[doc.docs.length - 1]
    //         }
    //         $state.loaded()
    //       } else {
    //         $state.complete()
    //       }
    //     })

    //   this.listeners.push(listener)
    // },
    companyChange () {
      this.detachListeners()
      this.lastVisible = ''
      this.users = []
      this.$refs.InfiniteLoading.stateChanger.reset()
      this.lastDocSnapshot = null
      this.location = undefined
      if (this.company) this.setLocations()
    },
    resetInfiniteLoader () {
      this.detachListeners()
      this.lastVisible = ''
      this.lastDocSnapshot = null

      this.users = []
      if (this.$refs.InfiniteLoading) {
        this.$refs.InfiniteLoading.stateChanger.reset()
      }
    },
    async setLocations () {
      const _locations = await df.doc(`user_locations/${auth.currentUser.uid}.${this.company.id}`).get()

      let locations = []
      if (_locations?.data()?.locations) {
        locations = Object.keys(_locations.data().locations).map(key => {
          return _locations?.data()?.locations[key]
        })
      }
      this.locations = clone(locations.sort((a, b) => a.name.localeCompare(b.name)))
    },
    addUser () {
      this.$refs.addUser.open(this.companies)
    },
    editUser (user) {
      if (user.status !== 'PROCESSING') {
        this.$refs.editUser.open(user, this.company)
      }
    },
    onSearchInput (value) {
      const searchString = value || ''
      if (!searchString) {
        EventBus.$emit(this.searchEmitDestination, { searchString: '', triGramObject: null })
        return
      }
      const triGramObject = this.triGram(searchString)
      EventBus.$emit(this.searchEmitDestination, { searchString, triGramObject })
    },
    onSearchClear () {
      this.searchString = ''
      EventBus.$emit(this.searchEmitDestination, { searchString: '', triGramObject: null })
    }
  }
}
</script>

<style scoped>
.users-sticky-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #ffffff;
  padding: 14px 0 0;
  border-bottom: 1px solid #EEF2F5;
  border-left: 3px solid #00BCD4;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
}

.controls-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px 16px;
}

.controls-search {
  max-width: 240px;
}

.controls-select {
  max-width: 200px;
}

/* filter-select — matches Receipts.vue */
.filter-select {
  min-width: 0 !important;
}

.filter-select.v-text-field--outlined >>> fieldset {
  border-color: #B0BEC5 !important;
  border-width: 1.5px !important;
  border-radius: 8px !important;
}

.filter-select.v-text-field--outlined:hover >>> fieldset {
  border-color: #90A4AE !important;
}

.filter-select.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #00838F !important;
  border-width: 2px !important;
}

.filter-select >>> .v-input__slot {
  background: #ffffff !important;
  min-height: 38px !important;
  max-height: 38px !important;
  padding: 0 8px !important;
  border-radius: 8px !important;
}

.filter-select >>> .v-select__selection,
.filter-select >>> .v-text-field__slot input {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #263238 !important;
  letter-spacing: 0.3px !important;
}

.filter-select >>> label {
  font-size: 11px !important;
  font-weight: 500 !important;
  color: #37474F !important;
}

.users-thead {
  display: flex;
  align-items: center;
  padding-top: 12px;
  padding-bottom: 12px;
  margin-top: 14px;
  margin-left: 3px;
  border-bottom: 1px solid #EEF2F5;
  background-color: #ffffff;
}

.users-thead-cell {
  font-size: 12px;
  font-weight: 600;
  color: #64748B;
  padding: 8px 16px;
}

.users-tbody {
  max-height: calc(100vh - 240px);
  overflow-y: auto;
}

.user-cell {
  padding: 10px 16px;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.87);
}

.user-name {
  font-weight: 700;
}

.users-rows-body {
  background: #F5F7FA;
  padding: 6px 0 2px;
}

.user-card {
  border: 1px solid #EEF2F5 !important;
  border-left: 3px solid #E0E0E0 !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  margin-bottom: 4px !important;
  overflow: hidden !important;
  transition: border-left-color 0.15s ease, border-color 0.15s ease, background 0.15s ease !important;
}

.user-card-active  { border-left-color: #4ADE80 !important; }
.user-card-inactive { border-left-color: #F87171 !important; }

.user-card:hover {
  border-color: #00BCD4 !important;
  background: #F8FAFB !important;
  box-shadow: none !important;
}

.status-chip-active {
  background-color: #E8F5E9 !important;
  color: #2E7D32 !important;
  font-weight: 600 !important;
}

.status-chip-inactive {
  background-color: #FFEBEE !important;
  color: #C62828 !important;
  font-weight: 600 !important;
}

.add-user-btn {
  background: rgba(0, 188, 212, 0.08) !important;
  color: #00838F !important;
  border: 1.2px solid #00b3be !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  letter-spacing: 0.3px !important;
  padding: 0 16px !important;
  height: 38px !important;
  min-height: 38px !important;
  max-height: 38px !important;
  white-space: nowrap;
}

.add-user-btn:hover {
  background: rgba(0, 179, 190, 0.12) !important;
  box-shadow: none !important;
}

.add-user-btn::before {
  box-shadow: none !important;
}

.add-user-btn .v-icon {
  color: #00BCD4 !important;
  font-size: 17px !important;
}
</style>
